module.exports = __webpack_public_path__ + "files/9a599f54797d2ae5a61a3243b4e816fb.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-300italic.eot
// module id = 579
// module chunks = 59